/**
 * Route for `plan-pause`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { PlanPausePage } from "../features/plan-pause/PlanPausePage";

export const planPauseRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/plan-pause",
	component: PlanPausePage,
});

export default planPauseRoute;
